const { notEmptyValidator } = require('@/views/fusion/investment/intelligence-create/tools/form/validator');

const campaign_name = {
  label: '计划名称',
  type: 'input',
  rules: [
    {
      required: true,
      message: '请输入计划名称',
      trigger: ['change'],
      validator: notEmptyValidator,
    },
  ],
  word_list: ['定向包名称'],
  props: {
    placeholder: '请输入计划名称',
  },
  value: '',
  isPreview: false,
};

const fusion__campaign_num = {
  label: '新建广告数',
  type: 'radio-group',
  isButton: true,
  rules: {
    required: true,
    message: '请选择新建广告数',
    trigger: ['change'],
  },
  options: [
    {
      label: '按渠道数',
      value: 'channel_num',
    },
  ],
  value: 'channel_num',
};

/**
 * 广告：基础配置
 */
export {
  campaign_name, // 计划名称
  fusion__campaign_num, // 新建广告数
};
